import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  private groupsCache = new BehaviorSubject<any>(null);
  private cacheTimestamp: number = 0;
  private readonly CACHE_DURATION = 5 * 60 * 1000; // 5 minutes
  private isCacheValid = false;

  getCachedGroups(): Observable<any> | null {
    if (this.isCacheValid && Date.now() - this.cacheTimestamp < this.CACHE_DURATION) {
      return this.groupsCache.asObservable();
    }
    return null;
  }

  setCache(groups: any): void {
    this.groupsCache.next(groups);
    this.cacheTimestamp = Date.now();
    this.isCacheValid = true;
  }

  invalidateCache(): void {
    this.isCacheValid = false;
    this.groupsCache.next(null);
  }

  forceRefresh(): void {
    this.invalidateCache();
  }

  isCacheAvailable(): boolean {
    return this.isCacheValid && Date.now() - this.cacheTimestamp < this.CACHE_DURATION;
  }
}